import React from "react";
import styles from "./DrPrimeInfoCard.module.css";
import {
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

import {
  FaXTwitter,
  FaPinterestP,
} from "react-icons/fa6";

const actionButtons = [

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18M5 8l7-5 7 5M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8"></path>
      </svg>
    ),
    label: "Sleep Guide",
    desc: "Get the most out of it",
    href: "https://www.mydrprime.com/pages/sleep-guide",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17h.01"></path>
      </svg>
    ),
    label: "FAQ",
    desc: "Common questions",
    href: "https://www.mydrprime.com/pages/faq",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path>
      </svg>
    ),
    label: "Contact Support",
    desc: "We reply within 24 hours",
    href: "https://www.mydrprime.com/pages/contact",
  },
];

const socials = [
  { icon: <FaInstagram />, href: "https://www.instagram.com/drprime.store/", label: "Instagram" },
  { icon: <FaLinkedinIn />, href: "https://www.linkedin.com/company/mydrprime/", label: "linkedin" },
  {
    icon: <FaPinterestP />,
    href: "https://in.pinterest.com/mydrprime/",
    label: "Pinterest",
  },
  {
    icon: <FaXTwitter />,
    href: "https://x.com/mydrprime",
    label: "X",
  },
];

const DrPrimeInfoCard = () => {
  return (
    <div className={styles.pageShell}>
      <div className={styles.bgLayer}>
        <svg viewBox="0 0 500 900" preserveAspectRatio="none">
          <defs>
            <path id="four-star" d="M 0 -8 L 1.5 -1.5 L 8 0 L 1.5 1.5 L 0 8 L -1.5 1.5 L -8 0 L -1.5 -1.5 Z" fill="#8FBFEF" />
          </defs>
          <path d="M0,150 C140,70 240,230 500,120 L500,0 L0,0 Z" fill="#8FBFEF" opacity="0.10" className={styles.wave1}/>
          <path d="M0,780 C260,670 360,830 500,750 L500,900 L0,900 Z" fill="#3B3F99" opacity="0.14" className={styles.wave2}/>
          
          <g transform="translate(40, 90) scale(0.9)"><use href="#four-star" className={styles.star}/></g>
          <g transform="translate(420, 60) scale(1.2)"><use href="#four-star" className={styles.star} style={{animationDuration: "4s", animationDelay: "1s"}}/></g>
          <g transform="translate(370, 780) scale(0.8)"><use href="#four-star" className={styles.star} style={{animationDuration: "2.5s", animationDelay: "0.5s"}}/></g>
          <g transform="translate(60, 650) scale(1.1)"><use href="#four-star" className={styles.star} style={{animationDuration: "3.5s", animationDelay: "2s"}}/></g>
          <g transform="translate(250, 40) scale(0.7)"><use href="#four-star" className={styles.star} style={{animationDuration: "2.8s", animationDelay: "1.5s"}}/></g>
          <g transform="translate(460, 400) scale(1)"><use href="#four-star" className={styles.star} style={{animationDuration: "3.2s", animationDelay: "0.2s"}}/></g>
          <g transform="translate(30, 420) scale(1.3)"><use href="#four-star" className={styles.star} style={{animationDuration: "4.5s", animationDelay: "0.8s"}}/></g>
          <g transform="translate(200, 830) scale(0.8)"><use href="#four-star" className={styles.star} style={{animationDuration: "3.8s", animationDelay: "2.2s"}}/></g>
          <g transform="translate(440, 220) scale(1)"><use href="#four-star" className={styles.star} style={{animationDuration: "2.9s", animationDelay: "1.1s"}}/></g>
        </svg>
      </div>

      <div className={styles.content}>
        <img
          src="/Dr. Prime-transperent.png"
          alt="Dr.Prime"
          className={styles.logo}
        />
        <h1 className={styles.heading}>
          Your Journey to Better Sleep<br />with Dr. Prime
        </h1>
        <div className={styles.tagline}>Invest In Your Health.</div>
        
        <div className={styles.links}>
          {actionButtons.map((btn, i) => (
            <a key={i} href={btn.href} target="_blank" rel="noopener noreferrer" className={styles.linkCard} style={{ animationDelay: `${0.5 + i * 0.1}s` }}>
              <div className={styles.icon}>{btn.icon}</div>
              <div className={styles.linkText}>
                <div className={styles.linkTitle}>{btn.label}</div>
                <div className={styles.linkSub}>{btn.desc}</div>
              </div>
              <div className={styles.arrow}>&rarr;</div>
            </a>
          ))}
        </div>
        
        <div className={styles.socialRow}>
          {socials.map((s, i) => (
            <a
              key={i}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className={styles.socialIcon}
              style={{ animationDelay: `${0.6 + i * 0.1}s` }}
            >
              {s.icon}
            </a>
          ))}
        </div>
        
        <footer className={styles.footer}>
          &copy; {new Date().getFullYear()} Dr. Prime™ &middot; Invest In Your Health.<br />
          <a href="https://www.mydrprime.com" target="_blank" rel="noopener noreferrer">mydrprime.com</a>
        </footer>
      </div>
    </div>
  );
};

export default DrPrimeInfoCard;
